import { render, staticRenderFns } from "./oilStation.vue?vue&type=template&id=527716b6&scoped=true"
import script from "./oilStation.vue?vue&type=script&lang=js"
export * from "./oilStation.vue?vue&type=script&lang=js"
import style0 from "./oilStation.vue?vue&type=style&index=0&id=527716b6&prod&scoped=true&lang=css"
import style1 from "./oilStation.vue?vue&type=style&index=1&id=527716b6&prod&lang=css"
import style2 from "./oilStation.vue?vue&type=style&index=2&id=527716b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527716b6",
  null
  
)

export default component.exports